module.exports = __webpack_public_path__ + "img/9-3.706b942b.jpg";